import React, { Component } from "react";
import {getFavoriteAuthor,removeFavoriteAuthor,addFavoriteAuthor,authorslist_all} from '../config/Variables';
export default class FetchUserpopupV2 extends Component {

  constructor() {
    super();
    this.state = {
      hobbies: [],
      tid: '',
      messagelog: '',
      isLoading: true,
      users: [],
      numberstid: [],
      error: null
    }
    this.handleInputChangeUser = this.handleInputChangeUser.bind(this);
    this.RemovetidUser = this.RemovetidUser.bind(this);
   
  }


  handleInputChangeUser(event) {
    const target = event.target;
    var value = target.value;
   
    if (target.checked) {
      this.state.hobbies.push(value);
     // this.setState({messagelog:"اختر الكاتب المفضل لديك"});
    } else {
      
    // this.state.hobbies= this.state.hobbies.filter(a => a !== value);

      const index = this.state.hobbies.indexOf(value);
 
      if (index > -1) {
        this.state.hobbies.splice(index, 1);
        
        this.state.hobbies.splice(index, 1)
        const x = this.state.hobbies.indexOf(value);
    
        if (this.state.hobbies.indexOf(value) > -1) {
          this.state.hobbies.splice(index, 1);
         } // 2nd parameter means remove one item only
      }
     // this.state.hobbies.splice(value, 1);
    }
  }

   async RemovetidUser(event) {

    const target = event.target;
    var value = target.value;

    if (event.target.checked) {
      this.state.hobbies.push(value);
     // this.setState({messagelog:"اختر الكاتب المفضل لديك"});
    } else {
  const index = (this.state.hobbies).indexOf(parseInt(value, 2));
 
  for( var i = 0; i < this.state.hobbies.length; i++){ 
    if ( this.state.hobbies[i] == value) { 
      this.state.hobbies.splice(i, 1); 
    }
}
      if (localStorage.getItem('user-info')) {
        const tid = value

        let item = { tid };
        let user = JSON.parse(localStorage.getItem('user-info'))
        let result =  await fetch(removeFavoriteAuthor, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Accept": 'application/json',
            "Authorization": "Bearer " + user.token.access_token,
          },
          body: JSON.stringify(item)
        });
        result = await result.json();
  
        if (result.message.code == '200') {
          //localStorage.setItem("user-info", JSON.stringify(result));
          //history('/add');
          this.props.fetchuserpopupcallback(tid);

        }
      }
     // this.state.hobbies.splice(value, 1);
    }
  }


  async submituser() {
    const tid = this.state.hobbies.join(',')

    let item = { tid };
    if(tid==""){
      this.setState({messagelog:"اختر الكاتب المفضل لديك"});
    }else{
    if (localStorage.getItem('user-info')) {

      let user = JSON.parse(localStorage.getItem('user-info'))
      let result = await fetch(addFavoriteAuthor, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": 'application/json',
          "Authorization": "Bearer " + user.token.access_token,
        },
        body: JSON.stringify(item)
      });
      result = await result.json();

      if (result.message.code == '200') {
        //localStorage.setItem("user-info", JSON.stringify(result));
        //history('/add');
       // this.props.fetchownusercallback("selectauthorpopup");
        window.location.reload(false);
      }
    }
  }
 
  }
  getFetchUserspopup() {
    let user = JSON.parse(localStorage.getItem('user-info'));
    var numberstid_constant=[];
    var numberstid_hobbies=[];
    let datt = fetch(getFavoriteAuthor, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": 'application/json',
        "Authorization": "Bearer " + user.token.access_token,
      },
      body: JSON.stringify(this.state)
    }).then(response => response.json())
      .then(data => {
        data.data.map(({ tid }, index2) => {
        //  this.state.numberstid.push(tid);
          
         // this.setState({ numberstid: this.state.numberstid })
          //this.state.hobbies.push(tid);
          numberstid_constant.push(tid);
          numberstid_hobbies.push(tid);
        });
     
    this.setState({
      loading: true
    }, () => {
      fetch(authorslist_all).then(res => res.json()).then(result => this.setState({
        loading: false,
        users: result.rows,
        numberstid: numberstid_constant,
        hobbies:numberstid_hobbies
      })).catch(console.log);
    });
  });
  }
  componentDidMount() {
    this.getFetchUserspopup();
  }

  render() {
    const {
      users,
      error
    } = this.state;

    return (

    
      <div class="modal-wrap" data-modal="modal-author" id="tagsCheckedModal">
        
            <div class="modal-overlay modal-toggle"></div>
            <div class="modal-wrapper modal-transition">
                <div class="modal-before">
                <button className="modal-close">
                  <span aria-hidden="true">&times;</span>
              </button>
              <button onClick={() => this.submituser()} className="button modal-close primary-light rounded select-all"><i className="icomoon-icon icon-check-green"></i><span aria-hidden="true"> تم</span> </button>
                </div>
                <div class="modal-inner">
                    <div class="topper-title text-center margin-bottom-3">
                        <h3>تابع كُتابك المفضلين</h3> 
                        <p>اختر كُتابك المفضلين لتحصل على تجربة مميزة</p>
                    </div> 
        
                    <div class="vertical-scroll-wrapper"> 
                        <div class="vertical-scroll-inner v-scroller_js">


                    
            <div className="authors-list v-inner-scroll">
              
              <React.Fragment>
                {
                  users.map(({ name, tid, field_opinion_writer_photo_export }, index) => {
                    const fruitss = this.state.numberstid;
                    const ttt = parseInt(tid);
                    const ss = fruitss.includes(ttt); //true

                    if (ss){
                      return (
                        <div className="author-option" id={Math.random()} key={index}>
                           
                          <label for={`custom-user-checkbox-author-${index}`} className="multi-check">
                            <input type="checkbox" id={`custom-user-checkbox-author-${index}`}
                              name="hobbiesuser" defaultChecked={true}  defaultValue={`${tid}`}
                              className="form-check"   onTouchEnd={this.RemovetidUser} onClick={this.RemovetidUser}  />
                            <div className="author-img round">
                            {field_opinion_writer_photo_export ?
                               <img src={field_opinion_writer_photo_export.startsWith("s3/")?"https://static.srpcdigital.com/styles/large/public/2022-06/Logo-Asharq-07062022.jpg?itok=Z47SDY13":field_opinion_writer_photo_export} alt="author" />
                            :<img src="https://static.srpcdigital.com/styles/large/public/2022-06/Logo-Asharq-07062022.jpg?itok=Z47SDY13" /> }
                            </div>
                            <div className="author-meta">
                              <div className="author-name">{name}</div>

                            </div>
                          </label>
                        </div>
                      );

                    } else {
                      return (
                        <div className="author-option" key={index}>
                          <label htmlFor={`custom-user-checkbox-author-${index}`} className="multi-check">
                            <input type="checkbox"  id={`custom-user-checkbox-author-${index}`}
                              name="hobbiesuser" defaultValue={`${tid}`}
                              className="form-check" onClick={this.handleInputChangeUser} />
                            <div className="author-img round">
                             
                            {field_opinion_writer_photo_export ?
                               <img src={field_opinion_writer_photo_export.startsWith("s3/")?"https://static.srpcdigital.com/styles/large/public/2022-06/Logo-Asharq-07062022.jpg?itok=Z47SDY13":field_opinion_writer_photo_export} alt="author" />
                            :<img src="https://static.srpcdigital.com/styles/large/public/2022-06/Logo-Asharq-07062022.jpg?itok=Z47SDY13" /> }
                            </div>
                            <div className="author-meta">
                              <div className="author-name">{name}</div>

                            </div>
                          </label>
                        </div>
                      );
                    }
                  })
                }
              </React.Fragment>
              </div>
          </div>
        </div>
      </div>
      </div>
      </div>
  

    );
  }
}
